loadElpaisScript();
setUpGlobals();
setInterval(hideOriginalAds, 1000);

function setUpGlobals() {
  window.__ark_ads__ = window.__ark_ads__ || {};
  window.__ark_ads__.core = window.__ark_ads__.core || {} as any;
  window.__ark_ads__.displayAd = window.__ark_ads__.displayAd || { ArkGoogleTag: {} };
  window.__ark_ads__.displayAdReady = (fn: Function) => { fn() };
}

function loadElpaisScript() {
  const src = 'https://ak-ads-ns.prisasd.com/slot/elpais_juegos/slot.js';
  if (document.querySelector(`script[src="${src}"]`)) return;
  const script = Object.assign(document.createElement('script'), { src, defer: '' });
  (document.head || document.body).appendChild(script);
}

function hideOriginalAds() {
  const elements = [
    ...document.querySelectorAll('div[class*="DisplayAd__container"]'),
    ...document.querySelectorAll('div[class*="RightRail__displayAdRight"]'),
  ] as HTMLDivElement[];
  // document.getElementById('root')!.style.marginTop = '250px';
  elements.forEach(el => el.style.display = 'none');
  // const rr = document.querySelector('div[style^="position: sticky"]') as HTMLDivElement;
  // if (rr) rr.style.display = 'none';

  // const t1 = document.querySelector('div[data-element-description="ark-display-top"]') as HTMLDivElement;
  // if (t1) t1.style.display = 'none';

  // const t2 = document.querySelector('div[data-element-description="ark-display-bottom"]') as HTMLDivElement;
  // if (t2) t2.style.display = 'none';
}

if (!customElements.get('display-ad-component')) {
  customElements.define('display-ad-component', class DisplayAd extends HTMLElement {
    coreService = {};
  });
}
